
import { VCardText } from "vuetify/lib";

// Functional component
export default VCardText;
